export default {
    selectAll: 'Sélectionner tout',
    unselectAll: 'Désélectionner tout',
    addTextDestinataire: 'Veuillez saisir une destinataire',
    invalidPhoneNumberPrefix: 'Seuls les numéros commençant par 034 ou 038 peuvent recevoir un message.',
    addNewMessage: 'Veuillez saisir le message !',
    sendMessage: 'Envoyer message',
    emptySelectedSMSDescription: 'Cliquer sur une ligne dans le tableau pour afficher le contenu du SMS.',
    emptySelectedSMSTitle: 'Aperçu de message',
    tabs: {
        SEND_BOX: 'sendbox',
        OUT_BOX: 'outbox',
    },
};
